import React from 'react';

const OfferStepTitle = ({ currentStep, hasProductPlanSupport }) => {
  const getTitle = () => {
    switch (currentStep) {
      case 'category':
        return '¿Qué producto vas a vender?';
      case 'productPlan':
        return hasProductPlanSupport ? 'Selecciona un plan de financiación' : '¿Qué producto vas a vender?';
      case 'productForm':
        return 'Ingresa los detalles del producto';
      case 'offers':
        return 'Selecciona tu plan de pago';
      default:
        return '¿Qué producto vas a vender?';
    }
  };

  return (
    <div className="col-12 mb-4">
      <h4 className="text-center rg-sale-quote-step__title rg-sale-step__title">{getTitle()}</h4>
    </div>
  );
};

export default OfferStepTitle;
